import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { TimeProvider, TimeEvent } from '../time.provider';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'event-timeline',
    templateUrl: './event.timeline.html',
    styleUrls: ['./event.timeline.scss']
})
export class Timeline implements OnInit, OnChanges, OnDestroy {

    @Input("filter")
    filter: any;

    @Input('tagsets')
    tagsets: any[] = [];

    @Output('select')
    onSelect: EventEmitter<TimeEvent> = new EventEmitter<TimeEvent>();

    @Output('edit')
    onEdit: EventEmitter<TimeEvent> = new EventEmitter<TimeEvent>();

    data: TimeEvent[] = [];
    // private Lcount: number = 0;
    // private Dlocunt: number = 0;
    // private comments: number = 0;

    paramSub: Subscription;

    constructor(private provider: TimeProvider, private route: ActivatedRoute) {}

    ngOnInit() {
    
        if (this.filter) {
            this.fetch(this.filter);
            return;
        }

        if (!this.tagsets) {
            this.provider.getTagsets()
            .then(data => {
                this.tagsets = data;
            })
        }
     
        this.paramSub = this.route.queryParamMap.subscribe({
            next: (map) => {
                let filter: any = {};
                filter.from = map.get('from');
                filter.to = map.get('to');

                filter.id = map.get('id');
                filter.parent = map.get('parent');
                filter.root = map.get('root');

                filter.tag = map.get('tag');
                filter.res = map.get('res');

                this.fetch(filter);
            }
        })
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.filter) {
            let from = this.filter.from;
            if (from instanceof Date) {
                this.filter.from = from.getFullYear() + '-' + (from.getMonth() + 1) + '-' + from.getDate();
            }
            let to = this.filter.to;
            if (to instanceof Date) {
                this.filter.to = to.getFullYear() + '-' + (to.getMonth() + 1) + '-' + to.getDate();
            }

            let newFilter = {};
            for(let key of Object.keys(this.filter)) {
                newFilter[key] = this.filter[key];
            }
            this.filter = newFilter;
            this.fetch(this.filter);
        }
    }

    ngOnDestroy() {
        if (this.paramSub) this.paramSub.unsubscribe();
    }
     
    fetch(params: any) {    
        this.provider.getEventsDetailed(params)
        .then(events => {
            // console.log('Received: ', events);
            this.data = events;
        })
    }

    select(ev: TimeEvent) {
        this.onSelect.emit(ev);
    }

    edit(ev: TimeEvent) {
        if (ev && ev.id && this.onEdit.observers.length) {
            this.onEdit.emit(ev);
        }
    }

    /*
    like(){
        this.Lcount++;
        //  let count=this.Lcount;
    }

    dislike(){
        this.Dlocunt++;
        // let count =this.Dlocunt;    
    }

    comment(){
        this.comments++;
        // let count =this.comments;    
    }
*/
}
